import { useInfiniteQuery } from "@tanstack/vue-query";
import { container } from "tsyringe";

// entities
import { AcademyRegistrationRequestQueryKeys } from "@/entities/academy-registration-request/infrastructure/query-keys";
import {
    AcademyRegistrationRequestRepository,
    RequestGetAcademyRegistrationRequestPayload,
} from "@/entities/academy-registration-request/domain/repository";

// features
import type { UseQueryRegistrationRequestsProps } from "@/features/pending-registration/models/interface";

export const useQueryRegistrationRequests = ({ academyId }: UseQueryRegistrationRequestsProps) => {
    const academyRegistrationRequestRepository =
        container.resolve<AcademyRegistrationRequestRepository>(
            "AcademyRegistrationRequestRepository",
        );

    const {
        data: registrationRequestsDto,
        isPending,
        isFetchingNextPage,
        fetchNextPage,
        hasNextPage,
        error,
        isFetchNextPageError,
    } = useInfiniteQuery({
        ...AcademyRegistrationRequestQueryKeys.academy_registration_requests.lists({
            academyId: academyId,
            size: 10,
            nextToken: undefined,
        }),
        initialPageParam: undefined,
        queryFn: async ({ pageParam }: { pageParam: string | undefined }) => {
            const payload: RequestGetAcademyRegistrationRequestPayload = {
                academyId: academyId,
                size: 10,
                nextToken: pageParam,
            };

            const response =
                await academyRegistrationRequestRepository.getAcademyRegistrationRequests(payload);

            return response;
        },
        getNextPageParam: (lastPage) => lastPage.nextToken,
        throwOnError: true,
        retry: 0,
    });

    return {
        registrationRequestsDto,
        isPending,
        error,
        isFetchingNextPage,
        fetchNextPage,
        hasNextPage,
        isFetchNextPageError,
    };
};
